/* eslint-disable react-hooks/exhaustive-deps */
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { InputAdornment, TextField } from '@mui/material';
import { validDecimal } from 'app/helpers/numberHelper';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectIsEditMod, selectIsEmiLmoDisabled } from 'store/redux-store/placement-mods/selectors';

export const LmoCostPerDay = () => {
  const { control, formState: { errors }, getValues, setValue, clearErrors, setError } = useFormContext();
  const { t } = useTranslation();
  const isModEdit = useSelector(selectIsEditMod);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const lmoDaysWaived: number | string | null | undefined = useWatch({ name: 'lmoDaysWaived' });
  const lmoCostPerDay: number | string | null | undefined = useWatch({ name: 'lmoCostPerDay' });
  const lateMoveOutDate: Date | string | null | undefined = useWatch({ name: 'lateMoveOutDate' });
  const lmoNumberOfDays: number | string | null | undefined = useWatch({ name: 'lmoNumberOfDays' });
  const isEmiLmoDisabled = useSelector(selectIsEmiLmoDisabled);
  const [required, setRequired] = useState<boolean>();

  useEffect(() => {
    if (
      (!isNullOrUndefined(lateMoveOutDate) && lateMoveOutDate !== '') ||
      (!isNullOrUndefined(getValues('lmoCostPerDay')) && getValues('lmoCostPerDay') !== '') ||
      (!isNullOrUndefined(getValues('lmoNumberOfDays')) && getValues('lmoNumberOfDays') !== '') ||
      (!isNullOrUndefined(getValues('lmoDaysWaived')) && getValues('lmoDaysWaived') !== '')
    ) {
      if (isNullOrUndefined(lmoCostPerDay) || lmoCostPerDay === '') {
        setError('lmoCostPerDay', t('placement.placementMods.costPerDayError'));
      } else {
        clearErrors('lmoCostPerDay');
      }
      setRequired(true);
    } else {
      setRequired(false);
    }
  }, [lateMoveOutDate, lmoCostPerDay, lmoDaysWaived, lmoNumberOfDays]);

  useEffect(() => {
    if (!required) {
      setTimeout(() => {
        clearErrors('lmoCostPerDay');
      }, 100);
    }
  }, [required]);

  return (
    <Controller
      control={control}
      name={'lmoCostPerDay'}
      rules={{
        required: required,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          value={getValues('lmoCostPerDay')}
          variant="filled"
          fullWidth
          id="lmoCostPerDay"
          color="primary"
          label={t('placement.placementMods.costperDay')}
          InputLabelProps={{
            shrink: lmoCostPerDay ? true : false,
            sx: { marginTop: lmoCostPerDay ? '0px' : '-10px' },
          }}
          inputProps={{ maxLenght: 6 }}
          InputProps={{
            readOnly: !isModEdit || isEmiLmoDisabled,
            style: {
              pointerEvents: (isModEdit || isSaveModApiCalling) && !isEmiLmoDisabled ? 'auto' : 'none',
            },
            startAdornment: <>{lmoCostPerDay && <InputAdornment position="start">$</InputAdornment>}</>,
          }}
          onChange={e => {
            if (validDecimal(e.target.value, { numberLength: 6, decimalLength: 4 })) {
              const validInput = e.target.value.replace(/^\./, '0.');
              setValue('lmoCostPerDay', validInput, { shouldDirty: true });
              onChange(validInput);
            }
          }}
          error={!!errors?.lmoCostPerDay}
          helperText={!isNullOrUndefined(errors?.lmoCostPerDay) ? errors?.lmoCostPerDay?.message : undefined}
          disabled={isSaveModApiCalling}
          required={required}
          {...rest}
        />
      )}
    />
  );
};
